module.exports = "<div class=alert-box> <div class=text> <p></p> </div> <div class=button> <button>确定</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/alert/alert.html
// module id = 1885
// module chunks = 50